import axios from 'axios';

export const apiAllExtensions = ({ pageSize, page, sorted, filtered }) => {
  const sort = sorted.map((column) => `${column.id},${column.desc ? 'desc' : 'asc'}`);
  const filter = filtered.map((column) => `${column.id},${column.value}`);
  return axios.get(`/api/admin/extensions`, { params: { limit: pageSize, page, sort, filter }, skipLoader: true });
};
export const apiRequestExtension = ({ token, ...payload }) =>
  axios.post('/api/extension', { ...payload, stripeToken: token });
export const apiGetExtenson = (id) => axios.get(`/api/admin/extension/${id}`);
export const apiApproveExtension = (id) => axios.post(`/api/admin/extension/${id}/approve`);
export const apiRejectExtension = (id) => axios.post(`/api/admin/extension/${id}/reject`);
